import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.EmployeeRoleEnumSortEnum>
) {
  const { pagination, sort, filter } = params;

  const {
    employeeRoleEnumList: { items: data, total },
  } = await sdk.getListEmployeeRoleEnum(
    filterSortPage({ filter, sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { employeeRoleEnum: data } = await sdk.getOneEmployeeRoleEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { employeeRoleEnumMany: data } = await sdk.getManyEmployeeRoleEnum({
    ids,
  });

  return {
    data,
  };
}

/*********************************************************************/
export const employeeRoleEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
